import React from 'react';
import AcquireWebComponent from "../framework/MaterialUI";

export default class NewNavigator extends AcquireWebComponent {

  nullHandle() {}

  render() {
    const options = this.props.options;
    return <div style={{
      display: 'flex',
      flexWrap: 'wrap',
    }}>
      {options.map((it, idx) => {
        const active = it.event !== undefined;
        return [<div className="_nav" key={it.name} style={{
          color: active ? '#017FB5' : '#000000'
        }} onClick={() => {it.event && it.event();}}>{it.name}</div>,
        <div style={{
          display: idx !== options.length - 1 ? 'block' : 'none',
          padding: '0 10px',
        }}>></div>
        ]
      })}
      {this.props.children}
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/Insights/newNavigator.jsx